// ListaParceiros.js

import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import CardParceiros from './CardParceiros';

export default function ListaParceiros() {
  return (
    <Container sx={{ py: 6 }}>
      {/* Títulos de Parceiros */}
      <Typography
                  variant="h2"
                  align="center"
                  gutterBottom
                  style={{
                    fontFamily: "'Lato', serif",
                    color: "#800020",
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                    borderBottom: "4px solid #d4af37",

                    paddingBottom: "10px",
                    textTransform: "uppercase",
                    animation: "glow 2s infinite alternate",
                    marginTop: "7%"  // Aqui é onde você define o espaço superior
                  }}
                >
        Instituições Parceiras
      </Typography>
       

      {/* Lista de Parceiros */}
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
        <CardParceiros
    src="/media/membros/GAHOM-AHLOMA.jpeg"
    text="GAHOM-AHLOMA - Groupe d`Anthropologie Historique de l`Occident médiéval"
    label=""
    path="http://ahloma.ehess.fr/"
    pathb="http://ahloma.ehess.fr/"
    sx={{ transform: 'scale(1.1)', transition: 'transform 0.3s ease' }} // Aumenta o tamanho do Card
  />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardParceiros
            src="/media/membros/University_Fribourg_004.jpeg"
            text="Université de Fribourg"
            label=""
            path="mailto:umahistoriadapeninsula@gmail.com"
            pathb="https://www.snf.ch/en"
            sx={{ transform: 'scale(1.1)', transition: 'transform 0.3s ease' }} // Aumenta o tamanho do Card

          />
        </Grid>
      </Grid>
    </Container>
  );
}
